/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 */
export function compact (layout, verticalCompact) {
  // We go through the items by row and column.
  const sorted = sortLayoutItemsByRowCol(layout)
  // Holding for new items.
  const out = new Array(layout.length)

  for (let i = 0, len = sorted.length; i < len; i++) {
    let l = sorted[i]
    // Add to output array to make sure they still come out in the right order.
    out[layout.indexOf(l)] = l
  }

  return out
}

export function getAllCollisions (appointments, item) {
  return appointments.filter((current) => collides(current, item))
}

/**
 * Given two layoutitems, check if they collide.
 */
export function collides (currentItem, item) {
  if (currentItem.split) return false
  if (currentItem.id === item.id) return false // same element
  if (currentItem.x !== item.x) return false // not same employee
  if (currentItem.y + currentItem.h <= item.y) return false // l1 is above l2
  if (currentItem.y >= item.y + item.h) return false // l1 is below l2
  return true // boxes overlap
}

export function setTransform (top, left, width, height) {
  // Replace unitless items with px
  const translate = 'translate(' + left + 'px,' + top + 'px)'
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  }
}

/**
 * Just like the setTransform method, but instead it will return a negative value of right.
 *
 * @param top
 * @param right
 * @param width
 * @param height
 * @returns {{transform: string, WebkitTransform: string, MozTransform: string, msTransform: string, OTransform: string, width: string, height: string, position: string}}
 */
export function setTransformRtl (top, right, width, height) {
  // Replace unitless items with px
  const translate = 'translate(' + right * -1 + 'px,' + top + 'px)'
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  }
}

export function setTopLeft (top, left, width, height) {
  return {
    top: top + 'px',
    left: left + 'px',
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  }
}
/**
 * Just like the setTopLeft method, but instead, it will return a right property instead of left.
 *
 * @param top
 * @param right
 * @param width
 * @param height
 * @returns {{top: string, right: string, width: string, height: string, position: string}}
 */
export function setTopRight (top, right, width, height) {
  return {
    top: top + 'px',
    right: right + 'px',
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  }
}

/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */
export function sortLayoutItemsByRowCol (layout) {
  return [].concat(layout).sort(function (a, b) {
    if (a.y > b.y || (a.y === b.y && a.x > b.x)) {
      return 1
    }
    return -1
  })
}

// Get {x, y} positions from event.
export function getControlPosition (e) {
  return offsetXYFromParentOf(e)
}

// Get from offsetParent
export function offsetXYFromParentOf (evt) {
  const offsetParent = evt.target.offsetParent || document.body
  const offsetParentRect = evt.offsetParent === document.body ? {left: 0, top: 0} : offsetParent.getBoundingClientRect()

  const x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left
  const y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top

  return {x, y}
}

// Create an data object exposed by <DraggableCore>'s events
export function createCoreData (lastX, lastY, x, y) {
  // State changes are often (but not always!) async. We want the latest value.
  const isStart = !isNum(lastX)

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    }
  } else {
    // Otherwise calculate proper values.
    return {
      deltaX: x - lastX,
      deltaY: y - lastY,
      lastX: lastX,
      lastY: lastY,
      x: x,
      y: y
    }
  }
}

export function isTouchDevice () {
  return (
    !!(typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
    (window.DocumentTouch &&
    typeof document !== 'undefined' &&
    document instanceof window.DocumentTouch))) ||
    !!(typeof navigator !== 'undefined' &&
    (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
  )
}

function isNum (num) {
  return typeof num === 'number' && !isNaN(num)
}

export function formatTime (value) {
  let tmp = parseFloat(value)
  let minutesPart = (tmp % 1).toFixed(2)
  let minutes = minutesPart * 60
  let hours = tmp - minutesPart
  return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes)
}



// WEBPACK FOOTER //
// ./src/components/timetable/utils.js